import { render, staticRenderFns } from "./LPMinimal.vue?vue&type=template&id=0a96bf30&"
import script from "./LPMinimal.vue?vue&type=script&lang=js&"
export * from "./LPMinimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports